<template>
  <div class="home" :style="backgroundStyle">
    <vs-navbar target-scroll="#hide-scroll-content" hide-scroll center-collapsed v-model="active">
      <template v-slot:left>
        <img :src="require('@/assets/TJ.jpg')" alt="Logo" style="height:100px;width: auto;">
      </template>
      <vs-navbar-item :active="active == 'guide'" id="guide" class="navbar-text">
        项目背景
      </vs-navbar-item>
      <vs-navbar-item :active="active == 'docs'" id="docs" class="navbar-text">
        基本功能
      </vs-navbar-item>
      <vs-navbar-item :active="active == 'components'" id="components" class="navbar-text">
        原理介绍
      </vs-navbar-item>
      <vs-navbar-item :active="active == 'license'" id="license" class="navbar-text">
        关于本站
      </vs-navbar-item>
      <template v-slot:right>
        <vs-button flat @click="openLoginDialog">登录</vs-button>
        <vs-button>Get Started</vs-button>
      </template>
    </vs-navbar>

    <div id="hide-scroll-content">
      <!-- 滚动内容 -->
    </div>

    <!-- 登录对话框（已加 form 和 autocomplete） -->
    <vs-dialog blur v-model="dialogVisible" not-close-on-backdrop>
      <template v-slot:header>
        <h4 class="not-margin">欢迎进入 <b>桥隧群级联推演系统</b></h4>
      </template>

      <form @submit.prevent="login">
        <div class="con-form">
          <vs-input v-model="input1" placeholder="邮箱" autocomplete="email">
            <template #icon>@</template>
          </vs-input>
          <vs-input type="password" v-model="input2" placeholder="密码" autocomplete="current-password">
            <template #icon><i class='bx bxs-lock'></i></template>
          </vs-input>
          <div class="flex">
            <vs-checkbox v-model="checkbox1">记住我</vs-checkbox>
            <a href="#">忘记密码?</a>
          </div>
        </div>
        <div class="footer-dialog">
          <vs-button block type="submit">登录</vs-button>
          <div class="new">
            初次登录? <a href="#" @click="openRegisterDialog">新建账户</a>
          </div>
        </div>
      </form>
    </vs-dialog>

    <vs-dialog blur v-model="loginSuccessDialogVisible">
      <template v-slot:header>
        <h4 class="not-margin">登录成功</h4>
      </template>
      <div class="con-form">
        <p>Welcome back!</p>
      </div>
      <template v-slot:footer>
        <vs-button block @click="closeLoginSuccessDialog">Close</vs-button>
      </template>
    </vs-dialog>

    <vs-dialog blur v-model="registerDialogVisible" not-close-on-backdrop>
      <template v-slot:header>
        <h4 class="not-margin">注册 <b>桥隧群级联推演系统</b></h4>
      </template>
      <div class="con-form">
        <vs-input v-model="registerEmail" placeholder="邮箱">
          <template #icon>@</template>
        </vs-input>
        <vs-input type="password" v-model="registerPassword" placeholder="密码">
          <template #icon><i class='bx bxs-lock'></i></template>
        </vs-input>
        <vs-input type="password" v-model="registerPasswordConfirm" placeholder="确认密码">
          <template #icon><i class='bx bxs-lock'></i></template>
        </vs-input>
      </div>
      <template v-slot:footer>
        <div class="footer-dialog">
          <vs-button block @click="register">注册</vs-button>
          <div class="new">
            已有账户? <a href="#" @click="openLoginDialogFromRegister">登录</a>
          </div>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { modelLoader } from '@/utils/ModelLoader';

export default {
  name: 'HomePage',
  async mounted() {
    try {
      await modelLoader.preloadAllModels();
      console.log('Models preloaded successfully');
    } catch (error) {
      console.error('Failed to preload models:', error);
    }
  },
  data() {
    return {
      active: 'guide',
      dialogVisible: false,
      loginSuccessDialogVisible: false,
      registerDialogVisible: false,
      input1: '',
      input2: '',
      checkbox1: false,
      registerEmail: '',
      registerPassword: '',
      registerPasswordConfirm: '',
      backgroundStyle: {
        backgroundImage: `url(${require('@/assets/22.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }
    };
  },
  watch: {
    // 监听登录对话框打开，手动补上原生 autocomplete 属性（防止 vs-input 未传递）
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          const emailInput = document.querySelector('.vs-dialog input[placeholder="邮箱"]');
          const pwdInput = document.querySelector('.vs-dialog input[placeholder="密码"]');
          if (emailInput) emailInput.setAttribute('autocomplete', 'email');
          if (pwdInput) pwdInput.setAttribute('autocomplete', 'current-password');
        });
      }
    }
  },
  methods: {
    openLoginDialog() {
      this.dialogVisible = true;
      this.registerDialogVisible = false;
    },
    openRegisterDialog() {
      this.dialogVisible = false;
      this.registerDialogVisible = true;
    },
    openLoginDialogFromRegister() {
      this.dialogVisible = true;
      this.registerDialogVisible = false;
    },
    async register() {
      if (this.registerPassword !== this.registerPasswordConfirm) {
        this.openNotification('top-right', 'danger', 'Error', 'Passwords do not match');
        return;
      }
      try {
        const response = await axios.post('https://bridgetunnelgroup.site/api/user/register', {
          email: this.registerEmail,
          password: this.registerPassword
        });
        if (response.status === 201 || response.status === 200) {
          this.openNotification('top-right', 'success', 'Success', '注册成功!');
          this.openLoginDialog();
        } else {
          this.openNotification('top-right', 'warn', 'Error', 'Unexpected response from server');
        }
      } catch (error) {
        this.openNotification('top-right', 'danger', 'Error', error.response?.data?.message || 'Network error or server not responding');
      }
    },
    async login() {
      try {
        const response = await axios.post('https://bridgetunnelgroup.site/api/user/login', {
          email: this.input1,
          password: this.input2
        });
        if (response.status === 200) {
          const userId = response.data.userId;
          if (userId) {
            localStorage.setItem('token', userId);
          }

          // ★ 登录成功后，主动让浏览器保存密码
          this.saveCredentialsToBrowser();

          this.openNotification('top-right', 'success', 'Success', 'Login successful!');
          this.$router.replace({ name: 'RoadNet' });
        } else {
          this.openNotification('top-right', 'warn', 'Error', 'Unexpected response from server');
        }
      } catch (error) {
        this.openNotification('top-right', 'danger', 'Error', error.response?.data?.message || 'Login failed');
      }
    },
    
async saveCredentialsToBrowser() {
  // 方法1：使用浏览器标准 PasswordCredential API（Edge 支持）
  if (window.PasswordCredential && navigator.credentials) {
    const cred = new window.PasswordCredential({   // ✅ 加 window.
      id: this.input1,
      password: this.input2,
      name: this.input1,
    });
    try {
      await navigator.credentials.store(cred);
      console.log('密码已通过 PasswordCredential 保存');
      return;
    } catch (e) {
      console.warn('PasswordCredential 存储失败，尝试兜底方式', e);
    }
  }
  
  // 兜底隐藏表单提交（和之前一样）
  const form = document.createElement('form');
  form.style.display = 'none';
  form.method = 'POST';
  form.action = '#';
  form.innerHTML = `
    <input type="text" name="username" value="${this.input1}" autocomplete="username">
    <input type="password" name="password" value="${this.input2}" autocomplete="current-password">
  `;
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
},

    closeLoginSuccessDialog() {
      this.loginSuccessDialogVisible = false;
    },
    openNotification(position, color, title, text) {
      this.$vs.notification({
        progress: 'auto',
        color,
        position,
        title,
        text
      });
    }
  }
};
</script>

<style lang="stylus">
.vs-dialog__overlay {
  pointer-events: none;
}
.vs-dialog__content {
  pointer-events: auto;
}
.home {
  background-image: url('@/assets/background.jpg');
  background-size: cover;
  background-position: center;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.not-margin {
  margin 0px;
  font-weight normal;
  padding 10px;
}
.con-form {
  width 100%;
  .flex {
    display flex;
    align-items center;
    justify-content space-between;
    a {
      font-size .8rem;
      opacity .7;
      &:hover {
        opacity 1;
      }
    }
  }
  .vs-checkbox-label {
    font-size .8rem;
  }
  .vs-input-content {
    margin 10px 0px;
    width calc(100%);
    .vs-input {
      width 100%;
    }
  }
}
.footer-dialog {
  display flex;
  align-items center;
  justify-content center;
  flex-direction column;
  width calc(100%);
  .new {
    margin 0px;
    margin-top 20px;
    padding 0px;
    font-size .7rem;
    a {
      color getColor('primary') !important;
      margin-left 6px;
      &:hover {
        text-decoration underline;
      }
    }
  }
  .vs-button {
    margin 0px;
  }
}
.vs-navbar-item .navbar-text {
  font-size 100px !important;
  font-weight bold;
  color getColor('primary');
  margin-right 20px;
  text-transform uppercase;
  transition color 0.3s;
  &:hover {
    color getColor('secondary');
  }
}
@media (max-width: 768px) {
  .vs-navbar-item .navbar-text {
    font-size 16px !important;
    margin-right 10px;
  }
}
</style>
